import { pushCellHistory } from "../pushCellHistory";
import { snapCells } from "../snapCells";
import { sortCells } from "../sortCells";
import { Cell, CELL_THRESHOLD, State } from "../types";

export type AddColumnAction = Readonly<{
  type: "ADD COLUMN";
  x: number;
}>;

export const addColumn = (state: State, action: AddColumnAction): State => {
  const cells: Array<Cell> = state.cells.reduce((prev, next) => {
    if (action.x <= next.minX || action.x >= next.maxX) {
      prev.push(next);
      return prev;
    }
    const newLeftCell = {
      ...next,
      maxX: action.x,
    };
    const newRightCell = {
      ...next,
      minX: action.x,
      selected:false
    };
    if (
      newLeftCell.maxX - newLeftCell.minX >= CELL_THRESHOLD &&
      newRightCell.maxX - newRightCell.minX >= CELL_THRESHOLD
    ) {
      prev.push(newLeftCell);
      prev.push(newRightCell);
    } else {
      prev.push(next);
    }
    return prev;
  }, [] as Array<Cell>);
  if (cells.length === state.cells.length) {
    return {
      ...state,
      mouseDragStart: null,
      mousePosition: null,
      showTableUI: true,
    };
  }
  return pushCellHistory(
    state,
    sortCells(snapCells(cells, state.zoneWidth, state.zoneHeight, CELL_THRESHOLD)),
    {
      mouseDragStart: null,
      mousePosition: null,
      showTableUI: true,
    },
  );
};
